import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SHARED_ENVIRONMENT } from '@k12/environment';

@Injectable({
  providedIn: 'root'
})
export class ProgramPartnerService {
  private http: HttpClient = inject(HttpClient);
  private sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private apiUrl = this.sharedEnvironment.adminApiUrl;

  // A note on program partner types: it was decided that they should be called User Types in the UI
  // I don't think it makes sense to rename everything in the codebase, so the service and method names remain as program partner types
  // For searchability: userType UserType user-type
  //                    programPartnerType ProgramPartnerType program-partner-type

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getProgramPartnerTypes(): Observable<any> {
    return this.http.get(`${this.apiUrl}/programpartnertypes`, { observe: 'response' });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getProgramPartner(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/partners/programpartners/${id}`, { observe: 'response' });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getAllProgramPartners(): Observable<any> {
    return this.http.get(`${this.apiUrl}/partners/programpartners`, { observe: 'response' });
  }
}
